// Used but never defined
export const GET_CONCESSIONAIRES_FAILED = undefined;

export const CONCURRENT_SESSION_ERROR = 'CONCURRENT_SESSION_EXISTS';
export const CANNOT_REUSE_PASSWORD = 'CANNOT_REUSE_PASSWORD';
export const PASSWORD_RESET_TOO_RECENTLY = 'PASSWORD_RESET_TOO_RECENTLY';

export const PASSWORD_TOO_SHORT = 'PASSWORD_TOO_SHORT';
export const PASSWORD_REQUIRES_NUMBER = 'PASSWORD_REQUIRES_NUMBER';
export const PASSWORD_REQUIRES_UPPER_CASE = 'PASSWORD_REQUIRES_UPPER_CASE';
export const PASSWORD_REQUIRES_LOWER_CASE = 'PASSWORD_REQUIRES_LOWER_CASE';
export const PASSWORD_REQUIRES_SPECIAL_CHARACTER = 'PASSWORD_REQUIRES_SPECIAL_CHARACTER';
export const PASSWORDS_DO_NOT_MATCH = 'PASSWORDS_DO_NOT_MATCH';

export const MUST_ASSIGN_ONE_LOCATION = 'MUST_ASSIGN_ONE_LOCATION';
export const MUST_ASSIGN_ROLE_AT_EACH_LOCATION = 'MUST_ASSIGN_ROLE_AT_EACH_LOCATION';
export const MALFORMED_TOKEN = 'MALFORMED_TOKEN';

export const NOT_AUTHORIZED = 'NOT_AUTHORIZED';
export const SERVER_ERROR = 'LOGGED_SERVER_ERROR';

export const LOCKED_USER_REQUIRES_NOTE = 'LOCKED_USER_REQUIRES_NOTE';
export const USER_WITH_EMAIL_ALREADY_EXISTS = 'USER_WITH_EMAIL_ALREADY_EXISTS';
export const CONFIRMATION_EMAIL_NOT_SENT = 'CONFIRMATION_EMAIL_NOT_SENT';

export const EMAIL_NOT_CONFIRMED = 'EMAIL_NOT_CONFIRMED';
export const TOO_MANY_LOGIN_ATTEMPTS = 'TOO_MANY_LOGIN_ATTEMPTS';
export const ACCOUNT_IS_LOCKED = 'ACCOUNT_IS_LOCKED';
export const RESEND_CONFIRMATION_ALREADY_SENT = 'RESEND_CONFIRMATION_ALREADY_SENT';
export const GET_USER_FAILED = 'GET_USER_FAILED';
export const GET_CONCESSIONAIRE_FAILED = 'GET_CONCESSIONAIRE_FAILED';
export const GET_CONCESSIONAIRE_PERMITS_FAILED = 'GET_CONCESSIONAIRE_PERMITS_FAILED';
export const MAY_ASSIGN_ONLY_ONE_CONCESSIONAIRE = 'MAY_ASSIGN_ONLY_ONE_CONCESSIONAIRE';
export const MUST_ASSIGN_ONE_CONCESSIONAIRE = 'MUST_ASSIGN_ONE_CONCESSIONAIRE';

export const GET_COOPERATORS_FAILED = 'GET_COOPERATORS_FAILED';
export const GET_COOPERATOR_EMPLOYEES_FAILED = 'GET_COOPERATOR_EMPLOYEES_FAILED';
export const SAVE_COOPERATOR_FAILED = 'SAVE_COOPERATOR_FAILED';
export const SAVE_COOPERATORS_FAILED = 'SAVE_COOPERATORS_FAILED';
export const SAVE_COOPERATOR_EMPLOYEES_FAILED = 'SAVE_COOPERATOR_EMPLOYEES_FAILED';
export const DELETE_COOPERATORS_FAILED = 'DELETE_COOPERATORS_FAILED';
export const DELETE_COOPERATOR_EMPLOYEES_FAILED = 'DELETE_COOPERATOR_EMPLOYEES_FAILED';
export const REQUIRE_UNIQUE_COOPERATOR_NAME = 'REQUIRE_UNIQUE_COOPERATOR_NAME';

export const USER_ACTION_FORBIDDEN = 'USER_ACTION_FORBIDDEN';
export const NON_SUBORDINATE_ROLE = 'NON_SUBORDINATE_ROLE';

export const EDITABLE_NOTES_ERROR = 'EDITABLE_NOTES_ERROR';
